import { ref } from 'vue';
import { useStore } from 'vuex';
import { fetchSmsBalance } from '@/features/SMSCampaigns/data';
export function useSmsBalance() {
    const store = useStore();
    const loadingBalance = ref(false);
    const updateBalance = async () => {
        loadingBalance.value = true;
        await fetchSmsBalance()
            .then(response => {
            const datetime = response.date.split(' ');
            store.commit('smsCampaigns/UPDATE_BALANCE', response.balance);
            store.commit('smsCampaigns/UPDATE_DATE_UPDATEDAT', datetime);
        })
            .finally(() => {
            loadingBalance.value = false;
        });
    };
    return { updateBalance, loadingBalance };
}
